var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
// Reports whose action needs signatures: the list's Signatures column, the
// generate dialog that says the report waits for them, the report task's
// signing request, and what an executed request offers (download, print,
// transmit). The election returns and the initialization report are held by
// the tally, per Post (and country); the Reports tab holds the participation
// report of a Post.
import { useContext, useEffect, useMemo, useState } from "react";
import { gql, useApolloClient, useMutation, useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { Alert, Box, Button, MenuItem, Typography } from "@mui/material";
import { Dialog } from "@sequentech/ui-essentials";
import { ETaskExecutionStatus } from "@sequentech/ui-core";
import { AuthContext } from "@/providers/AuthContextProvider";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { IPermissions } from "@/types/keycloak";
import { EReportType } from "@/types/reports";
import { GET_SIGNING_RULES } from "@/queries/SigningSettings";
import { GET_TASK_BY_ID } from "@/queries/GetTaskById";
import { FETCH_DOCUMENT } from "@/queries/FetchDocument";
import { SigningAction, SigningRequestStatus, SigningRequirement, } from "@/lib/signing/types";
import { useNotify } from "react-admin";
import { useNavigate } from "react-router-dom";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
import { useOptionalSigningRequest } from "@/hooks/useSignedAction";
import { useScopeNames } from "@/resources/ElectionEvent/Signatures/useSigningSettings";
import { CREATE_TRANSMISSION_PACKAGE } from "@/queries/CreateTransmissionPackage";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
import { SEND_TRANSMISSION_PACKAGE } from "@/queries/SendTransmissionPackage";
import { signedView } from "@/lib/signing/request";
import { ruleOf } from "@/resources/ElectionEvent/Signatures/signingSettings";
import { DownloadDocument } from "@/resources/User/DownloadDocument";
export var GET_HELD_REPORT_REQUESTS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query GetHeldReportRequests($electionEventId: uuid!) {\n        signingHeldReportRequests(election_event_id: $electionEventId) {\n            requests\n        }\n    }\n"], ["\n    query GetHeldReportRequests($electionEventId: uuid!) {\n        signingHeldReportRequests(election_event_id: $electionEventId) {\n            requests\n        }\n    }\n"
    /** The protected action of a report type, where it is signed: its rule says whether it needs signatures. */
])));
/** The protected action of a report type, where it is signed: its rule says whether it needs signatures. */
export var reportSigningAction = function (reportType) {
    switch (reportType) {
        case EReportType.ELECTORAL_RESULTS:
            return SigningAction.GenerateElectionReturns;
        case EReportType.INITIALIZATION_REPORT:
        case EReportType.PARTICIPATION_REPORT:
            return SigningAction.GenerateReports;
        default:
            return null;
    }
};
/** Whether the Reports tab generates a report type to be signed (the others are signed by the tally). */
export var heldByReports = function (reportType) {
    return reportType === EReportType.PARTICIPATION_REPORT;
};
/**
 * The signatures each report type needs, read when the viewer may read the
 * signing rules; `known` is false otherwise (the report then generates as
 * before, and its task says whether it waits for signatures).
 */
export function useReportSignatures(electionEventId) {
    var auth = useContext(AuthContext);
    var tenantId = useTenantStore()[0];
    var canRead = auth.isAuthorized(true, tenantId, IPermissions.SIGNING_RULES_READ);
    var data = useQuery(GET_SIGNING_RULES, {
        variables: { electionEventId: electionEventId },
        context: { headers: { "x-hasura-role": IPermissions.SIGNING_RULES_READ } },
        // The tenant's report list has no event, so no rules to read.
        skip: !canRead || !electionEventId,
    }).data;
    var rules = data === null || data === void 0 ? void 0 : data.sequent_backend_signing_rule;
    return useMemo(function () { return ({
        known: !!rules,
        needs: function (reportType) {
            var action = reportSigningAction(reportType);
            if (!action || !rules)
                return null;
            var rule = ruleOf(action, rules);
            return rule.requirement === SigningRequirement.Required ? rule.signatures : 0;
        },
    }); }, [rules]);
}
/** The Signatures column: "Needs n", "Off", or a dash for a report that takes none. */
export var ReportSignaturesCell = function (_a) {
    var needs = _a.needs;
    var t = useTranslation().t;
    if (needs === null)
        return _jsx(_Fragment, { children: "-" });
    return _jsx(_Fragment, { children: needs > 0 ? t("signing.results.needs", { n: needs }) : t("signing.results.off") });
};
/** "{Post}: the document is generated now. It can be printed and transmitted once n people have signed it." */
export var GenerateSignedReportDialog = function (_a) {
    var open = _a.open, title = _a.title, post = _a.post, needs = _a.needs, onClose = _a.onClose;
    var t = useTranslation().t;
    return (_jsx(Dialog, { variant: "info", open: open, title: title, ok: String(t("reportsScreen.actions.generate")), cancel: String(t("common.label.cancel")), handleClose: function (generate) { return onClose(generate); }, children: _jsx(Typography, { variant: "body2", children: t("signing.reports.generateNotice", { post: post, n: needs }) }) }));
};
/** The signing request a report task started, once the task says so. */
export function useReportTaskSigningRequest(taskId) {
    var _a, _b, _c;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _d = useQuery(GET_TASK_BY_ID, {
        variables: { task_id: taskId },
        skip: !taskId,
    }), data = _d.data, startPolling = _d.startPolling, stopPolling = _d.stopPolling;
    var task = (_a = data === null || data === void 0 ? void 0 : data.sequent_backend_tasks_execution) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
        var id = _a.id;
        return id === taskId;
    });
    var annotations = task === null || task === void 0 ? void 0 : task.annotations;
    var requestId = (_c = (_b = annotations === null || annotations === void 0 ? void 0 : annotations.signing_request) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null;
    var finished = (task === null || task === void 0 ? void 0 : task.execution_status) === ETaskExecutionStatus.SUCCESS ||
        (task === null || task === void 0 ? void 0 : task.execution_status) === ETaskExecutionStatus.FAILED ||
        (task === null || task === void 0 ? void 0 : task.execution_status) === ETaskExecutionStatus.CANCELLED;
    useEffect(function () {
        // Unsigned reports and previews finish without a signing annotation.
        if (taskId && !requestId && !finished) {
            startPolling(globalSettings.QUERY_FAST_POLL_INTERVAL_MS);
        }
        else {
            stopPolling();
        }
        return stopPolling;
    }, [
        taskId,
        requestId,
        finished,
        globalSettings.QUERY_FAST_POLL_INTERVAL_MS,
        startPolling,
        stopPolling,
    ]);
    return requestId;
}
/** The report document an executed request released. */
export var releasedDocumentId = function (data) {
    var _a;
    if (data.request.status !== SigningRequestStatus.Executed)
        return null;
    var id = (_a = data.request.execution_result) === null || _a === void 0 ? void 0 : _a.document_id;
    return typeof id === "string" ? id : null;
};
/**
 * What a released report offers in its panel: Download signed PDF, Print,
 * and for the election returns Transmit results.
 */
export var ReportCompletionActions = function (_a) {
    var _b;
    var data = _a.data;
    var t = useTranslation().t;
    var client = useApolloClient();
    var _c = useState(null), downloading = _c[0], setDownloading = _c[1];
    var navigate = useNavigate();
    var signing = useOptionalSigningRequest();
    var tally = useElectionEventTallyStore();
    var auth = useContext(AuthContext);
    var tenantId = useTenantStore()[0];
    var canTransmit = [IPermissions.MIRU_CREATE, IPermissions.MIRU_SEND].some(function (permission) {
        return auth.isAuthorized(true, tenantId, permission);
    });
    var requests = useHeldReportRequests(data.request.election_event_id, canTransmit &&
        data.request.action === SigningAction.GenerateElectionReturns &&
        data.request.status === SigningRequestStatus.Executed).requests;
    var target = requests.find(function (request) {
        return request.request_id === data.request.id &&
            request.election_id === data.request.election_id &&
            request.area_id === data.request.area_id;
    });
    var notify = useNotify();
    var _d = useState(false), openingTransmission = _d[0], setOpeningTransmission = _d[1];
    var _e = useState(false), transmissionError = _e[0], setTransmissionError = _e[1];
    var _f = useWidgetStore(), addWidget = _f[0], setWidgetTaskId = _f[1], updateWidgetFail = _f[2];
    var createPackage = useMutation(CREATE_TRANSMISSION_PACKAGE, {
        context: { headers: { "x-hasura-role": IPermissions.MIRU_CREATE } },
    })[0];
    var showTransmission = function (packageData, tallyId) {
        var _a;
        signing === null || signing === void 0 ? void 0 : signing.close();
        if (((_a = packageData.signing_request) === null || _a === void 0 ? void 0 : _a.id) && signing) {
            signing.open(packageData.signing_request.id, { eventId: data.request.election_event_id });
            return;
        }
        tally.setCreatingFlag(null);
        tally.setSelectedTallySessionData(packageData);
        tally.setTallyId(tallyId);
        tally.setElectionEventIdFlag(data.request.election_event_id);
        navigate("/sequent_backend_election_event/".concat(data.request.election_event_id, "?tabId=tally"));
    };
    var goToTransmission = function () { return __awaiter(void 0, void 0, void 0, function () {
        var tallyId, widget, response, taskId, _a;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    if (!(target === null || target === void 0 ? void 0 : target.tally_session_id) || !target.election_id || !target.area_id)
                        return [2 /*return*/];
                    tallyId = target.tally_session_id;
                    setOpeningTransmission(true);
                    setTransmissionError(false);
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, 4, 5]);
                    if (target.transmission_package) {
                        showTransmission(target.transmission_package, tallyId);
                        return [2 /*return*/];
                    }
                    if (!auth.isAuthorized(true, tenantId, IPermissions.MIRU_CREATE)) {
                        setTransmissionError(true);
                        return [2 /*return*/];
                    }
                    widget = addWidget(ETasksExecution.CREATE_TRANSMISSION_PACKAGE, undefined);
                    return [4 /*yield*/, createPackage({
                            variables: {
                                electionEventId: data.request.election_event_id,
                                electionId: target.election_id,
                                tallySessionId: tallyId,
                                areaId: target.area_id,
                                force: false,
                            },
                        })];
                case 2:
                    response = _h.sent();
                    taskId = (_d = (_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.create_transmission_package) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id;
                    if (((_e = response.errors) === null || _e === void 0 ? void 0 : _e.length) ||
                        ((_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f.create_transmission_package) === null || _g === void 0 ? void 0 : _g.error_msg) ||
                        !taskId) {
                        updateWidgetFail(widget.identifier);
                        setTransmissionError(true);
                        return [2 /*return*/];
                    }
                    setWidgetTaskId(widget.identifier, taskId, function () {
                        client
                            .query({
                            query: GET_HELD_REPORT_REQUESTS,
                            variables: { electionEventId: data.request.election_event_id },
                            context: { headers: { "x-hasura-role": IPermissions.MIRU_CREATE } },
                            fetchPolicy: "network-only",
                        })
                            .then(function (_a) {
                            var _b;
                            var refreshed = _a.data;
                            var packageData = (_b = refreshed.signingHeldReportRequests.requests.find(function (request) { return request.request_id === target.request_id; })) === null || _b === void 0 ? void 0 : _b.transmission_package;
                            if (packageData)
                                showTransmission(packageData, tallyId);
                            else
                                setTransmissionError(true);
                        })
                            .catch(function () { return setTransmissionError(true); });
                    });
                    notify(t("miruExport.create.success"), { type: "success" });
                    return [3 /*break*/, 5];
                case 3:
                    _a = _h.sent();
                    setTransmissionError(true);
                    return [3 /*break*/, 5];
                case 4:
                    setOpeningTransmission(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var documentId = releasedDocumentId(data);
    if (!documentId)
        return null;
    var electionEventId = data.request.election_event_id;
    var print = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fetched, url;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, client.query({
                        query: FETCH_DOCUMENT,
                        variables: { electionEventId: electionEventId, documentId: documentId },
                        fetchPolicy: "network-only",
                    })];
                case 1:
                    fetched = (_b.sent()).data;
                    url = (_a = fetched === null || fetched === void 0 ? void 0 : fetched.fetchDocument) === null || _a === void 0 ? void 0 : _a.url;
                    // The browser's PDF viewer prints it.
                    if (url)
                        window.open(url, "_blank", "noopener");
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "contained", onClick: function () { return setDownloading(documentId); }, children: t("signing.results.downloadSigned") }), ((_b = data.request.execution_result) === null || _b === void 0 ? void 0 : _b.protected) === true ? null : (_jsx(Button, { variant: "outlined", onClick: function () { return void print(); }, children: t("signing.results.print") })), data.request.action === SigningAction.GenerateElectionReturns && canTransmit ? (_jsx(Button, { variant: "outlined", disabled: !(target === null || target === void 0 ? void 0 : target.tally_session_id) || openingTransmission, onClick: function () { return void goToTransmission(); }, children: t("signing.results.transmit") })) : null, transmissionError ? (_jsx(Alert, { severity: "error", children: t("miruExport.create.error") })) : null, downloading ? (_jsx(DownloadDocument, { documentId: downloading, electionEventId: electionEventId, fileName: null, showReportPasswordDialog: true, onDownload: function () { return setDownloading(null); } })) : null] }));
};
/** Completion action available when a transmission request is reopened. */
export var TransmissionCompletionActions = function (_a) {
    var _b;
    var data = _a.data;
    var t = useTranslation().t;
    var auth = useContext(AuthContext);
    var tenantId = useTenantStore()[0];
    var notify = useNotify();
    var _c = useState(false), confirm = _c[0], setConfirm = _c[1];
    var _d = useState(false), sent = _d[0], setSent = _d[1];
    var _e = useMutation(SEND_TRANSMISSION_PACKAGE, {
        context: { headers: { "x-hasura-role": IPermissions.MIRU_SEND } },
    }), send = _e[0], loading = _e[1].loading;
    useEffect(function () {
        setConfirm(false);
        setSent(false);
    }, [data.request.id]);
    var target = useMemo(function () {
        try {
            var subject = signedView(data).subject;
            var tally = subject.tally_session_id;
            var destinations = subject.destinations;
            return typeof tally === "string" &&
                tally &&
                Array.isArray(destinations) &&
                destinations.length > 0 &&
                destinations.every(function (value) { return typeof value === "string"; })
                ? { tally: tally, count: destinations.length }
                : null;
        }
        catch (_a) {
            return null;
        }
    }, [data]);
    var request = data.request;
    if (request.action !== SigningAction.TransmitResults ||
        request.status !== SigningRequestStatus.Executed ||
        !auth.isAuthorized(true, tenantId, IPermissions.MIRU_SEND) ||
        !target ||
        !request.election_id ||
        !request.area_id)
        return null;
    var transmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, send({
                            variables: {
                                electionId: request.election_id,
                                areaId: request.area_id,
                                tallySessionId: target.tally,
                            },
                        })];
                case 1:
                    response = _e.sent();
                    if (((_b = response.errors) === null || _b === void 0 ? void 0 : _b.length) || !((_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.send_transmission_package) === null || _d === void 0 ? void 0 : _d.id)) {
                        notify(t("miruExport.send.error"), { type: "error" });
                        return [2 /*return*/];
                    }
                    setSent(true);
                    notify(t("miruExport.send.success"), { type: "success" });
                    return [3 /*break*/, 3];
                case 2:
                    _a = _e.sent();
                    notify(t("miruExport.send.error"), { type: "error" });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "contained", disabled: loading || sent, onClick: function () { return setConfirm(true); }, children: t("signing.results.sendTo", { count: target.count }) }), _jsx(Dialog, { variant: "info", open: confirm, title: String(t("tally.transmissionPackage.actions.send.dialog.title")), ok: String(t("tally.transmissionPackage.actions.send.dialog.confirm")), cancel: String(t("tally.transmissionPackage.actions.send.dialog.cancel")), handleClose: function (confirmed) {
                    setConfirm(false);
                    if (confirmed)
                        void transmit();
                }, children: t("tally.transmissionPackage.actions.send.dialog.description", {
                    name: (_b = data.area_name) !== null && _b !== void 0 ? _b : request.area_id,
                }) })] }));
};
/** Reads safe report references with a permission the viewer already holds. */
export function useHeldReportRequests(electionEventId, enabled) {
    var _a, _b;
    if (enabled === void 0) { enabled = true; }
    var auth = useContext(AuthContext);
    var tenantId = useTenantStore()[0];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var role = [
        IPermissions.SIGNING_REQUESTS_READ,
        IPermissions.SIGN_GENERATE_ELECTION_RETURNS,
        IPermissions.SIGN_GENERATE_REPORTS,
        IPermissions.REPORT_READ,
        IPermissions.MIRU_CREATE,
        IPermissions.MIRU_SEND,
    ].find(function (permission) { return auth.isAuthorized(true, tenantId, permission); });
    var _c = useQuery(GET_HELD_REPORT_REQUESTS, {
        variables: { electionEventId: electionEventId },
        context: role ? { headers: { "x-hasura-role": role } } : undefined,
        skip: !enabled || !role || !electionEventId,
        fetchPolicy: "network-only",
        pollInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
    }), data = _c.data, error = _c.error;
    return { requests: (_b = (_a = data === null || data === void 0 ? void 0 : data.signingHeldReportRequests) === null || _a === void 0 ? void 0 : _a.requests) !== null && _b !== void 0 ? _b : [], error: error };
}
export var ReportRequestLinks = function (_a) {
    var electionEventId = _a.electionEventId, reportType = _a.reportType, electionId = _a.electionId, reportId = _a.reportId, resultsEventId = _a.resultsEventId, resultsDocumentId = _a.resultsDocumentId, areaId = _a.areaId, _b = _a.variant, variant = _b === void 0 ? "button" : _b, onOpen = _a.onOpen;
    var t = useTranslation().t;
    var signing = useOptionalSigningRequest();
    var _c = useHeldReportRequests(electionEventId, !!signing && reportSigningAction(reportType) !== null), requests = _c.requests, error = _c.error;
    var _d = useScopeNames(electionEventId, !!signing && requests.length > 0), postName = _d.postName, countryName = _d.countryName;
    if (!signing)
        return null;
    if (error)
        return _jsx(Alert, { severity: "error", children: t("signing.waiting.loadError") });
    var held = requests.filter(function (request) {
        return [SigningRequestStatus.Waiting, SigningRequestStatus.Completed].includes(request.status) &&
            request.report_type === reportType &&
            (!electionId || request.election_id === electionId) &&
            (!reportId || !request.report_id || request.report_id === reportId) &&
            (!resultsEventId || request.results_event_id === resultsEventId) &&
            (!resultsDocumentId || request.results_document_id === resultsDocumentId) &&
            (areaId === undefined || request.area_id === areaId);
    });
    return (_jsx(_Fragment, { children: held.map(function (request) {
            var open = function () {
                signing.open(request.request_id, { eventId: electionEventId });
                onOpen === null || onOpen === void 0 ? void 0 : onOpen();
            };
            var label = [
                request.code,
                request.election_id ? postName(request.election_id) : null,
                request.area_id ? countryName(request.area_id) : null,
            ]
                .filter(Boolean)
                .join(" · ");
            return variant === "menu" ? (_jsxs(MenuItem, { onClick: open, children: [t("signing.results.openRequest"), " \u00B7 ", label] }, request.request_id)) : (_jsxs(Box, { sx: { display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }, children: [_jsx(Button, { size: "small", onClick: open, children: t("signing.results.openRequest") }), _jsxs(Typography, { variant: "caption", children: [_jsx("span", { children: request.code }), " \u00B7 ", label.slice(request.code.length + 3)] })] }, request.request_id));
        }) }));
};
var templateObject_1;
